webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(90);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueRouter = __webpack_require__(100);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vuetify = __webpack_require__(101);
	
	var _vuetify2 = _interopRequireDefault(_vuetify);
	
	__webpack_require__(83);
	
	var _vueCountryRegionSelect = __webpack_require__(89);
	
	var _vueCountryRegionSelect2 = _interopRequireDefault(_vueCountryRegionSelect);
	
	var _store = __webpack_require__(51);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vueResource = __webpack_require__(25);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _veeValidate = __webpack_require__(88);
	
	var _veeValidate2 = _interopRequireDefault(_veeValidate);
	
	var _contact_form = __webpack_require__(92);
	
	var _contact_form2 = _interopRequireDefault(_contact_form);
	
	var _tax_exemption_form = __webpack_require__(94);
	
	var _tax_exemption_form2 = _interopRequireDefault(_tax_exemption_form);
	
	var _catalog_request_form = __webpack_require__(91);
	
	var _catalog_request_form2 = _interopRequireDefault(_catalog_request_form);
	
	var _customer_interaction_form = __webpack_require__(93);
	
	var _customer_interaction_form2 = _interopRequireDefault(_customer_interaction_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuetify2.default);
	
	_vue2.default.use(_vueCountryRegionSelect2.default);
	
	_vue2.default.use(_vueRouter2.default);
	
	_vue2.default.use(_vueResource2.default);
	
	_vue2.default.use(_veeValidate2.default);
	
	var routes = [{
	  name: "contact_form",
	  path: "/",
	  component: _contact_form2.default
	}, {
	  name: "tax_exemption_form",
	  path: "/tax_exemption_form",
	  component: _tax_exemption_form2.default
	}, {
	  name: "catalog_request_form",
	  path: "/catalog_request_form",
	  component: _catalog_request_form2.default
	}, {
	  name: 'customer_interaction_form',
	  path: '/customer_interaction_form',
	  component: _customer_interaction_form2.default
	}];
	
	var router = new _vueRouter2.default({
	  routes: routes,
	  mode: "history"
	});
	
	new _vue2.default({
	  el: "#app",
	
	  template: "<App/>",
	
	  components: { App: _App2.default },
	
	  render: function render(h) {
	    return h(_App2.default);
	  },
	  router: router,
	  store: _store.store
	}).$mount("#app");

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(55);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(9);
	
	var _vueRecaptcha = __webpack_require__(24);
	
	var _vueRecaptcha2 = _interopRequireDefault(_vueRecaptcha);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "form2",
	  components: { VueRecaptcha: _vueRecaptcha2.default },
	  $_veeValidate: {
	    validator: "new"
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    interestsList: "interestsList"
	  })),
	  data: function data() {
	    return {
	      data: {
	        email: "",
	        company: "",
	        name: "",
	        address1: "",
	        address2: "",
	        city: "",
	        zip: "",
	        subscribe: true,
	        phone: "",
	        interests: [],
	        hear: [],
	        which: "",
	        additional: "",
	        country: "United States",
	        region: "Barbuda"
	      },
	      regions: ["Alabama", "Alaska", "American Samoa", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "District of Columbia", "Federated States of Micronesia", "Florida", "Georgia", "Guam", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Marshall Islands", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Northern Mariana Islands", "Ohio", "Oklahoma", "Oregon", "Palau", "Pennsylvania", "Puerto Rico", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virgin Island", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"],
	      countries: ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua &amp; Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia &amp; Herzegovina", "Botswana", "Brazil", "British Virgin Islands", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Cape Verde", "Cayman Islands", "Chad", "Chile", "China", "Colombia", "Congo", "Cook Islands", "Costa Rica", "Cote D Ivoire", "Croatia", "Cruise Ship", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Polynesia", "French West Indies", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kuwait", "Kyrgyz Republic", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Mauritania", "Mauritius", "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Pierre &amp; Miquelon", "Samoa", "San Marino", "Satellite", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "South Africa", "South Korea", "Spain", "Sri Lanka", "St Kitts &amp; Nevis", "St Lucia", "St Vincent", "St. Lucia", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor L'Este", "Togo", "Tonga", "Trinidad &amp; Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks &amp; Caicos", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Venezuela", "Vietnam", "Virgin Islands (US)", "Yemen", "Zambia", "Zimbabwe"],
	      hearList: ["Search Engine", "Advertisement", "Farm Show", "Other"],
	      alertStatus: false
	    };
	  },
	  mounted: function mounted() {
	    this.$validator.localize("en", this.dictionary);
	  },
	
	  methods: {
	    submitForm2: function submitForm2() {
	      var _this = this;
	
	      this.$validator.validateAll().then(function (valid) {
	        if (valid) {
	          _this.alertStatus = _this.$store.dispatch("submitForm2", _this.data);
	        }
	      });
	    },
	    closeHear: function closeHear() {
	      if (this.$refs.hear.isMenuActive == true) this.$refs.hear.isMenuActive = false;
	    },
	    closeInterests: function closeInterests() {
	      if (this.$refs.interests.isMenuActive == true) this.$refs.interests.isMenuActive = false;
	    }
	  }
	};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vueRecaptcha = __webpack_require__(24);
	
	var _vueRecaptcha2 = _interopRequireDefault(_vueRecaptcha);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: "form1",
		components: { VueRecaptcha: _vueRecaptcha2.default },
		$_veeValidate: {
			validator: "new"
		},
		data: function data() {
			return {
				data: {
					to: "sales@kencove.com",
					from: "",
					subject: "",
					message: "",
					email: ""
				},
				alertStatus: false,
				people: [{ text: "Sales", value: "sales@kencove.com" }, { text: "Customer Service", value: "customerservice@kencove.com" }, { text: "Accounting", value: "ar@kencove.com" }, { text: "Human Resources", value: "hr@kencove.com" }]
			};
		},
		mounted: function mounted() {
			this.$validator.localize("en", this.dictionary);
		},
	
		methods: {
			submitForm1: function submitForm1() {
				var _this = this;
	
				this.$validator.validateAll().then(function (valid) {
					console.log(_this.data);
					if (valid) {
						_this.alertStatus = _this.$store.dispatch("submitForm1", _this.data);
					}
				});
			},
			closeMenu: function closeMenu() {
				if (this.$refs.to.isMenuActive == true) this.$refs.to.isMenuActive = false;else this.$refs.to.isMenuActive = true;
			}
		}
	};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	
	var _vueUppyCloudinary = __webpack_require__(26);
	
	var _vueUppyCloudinary2 = _interopRequireDefault(_vueUppyCloudinary);
	
	__webpack_require__(22);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
			name: 'form3',
			components: {
					VueUppyCloudinary: _vueUppyCloudinary2.default
			},
			data: function data() {
					return {
							valid: false,
							data: {
									fName: '',
									lName: '',
									email: '',
									issue: '',
									description: '',
									enter: '',
									fileData: [],
									phone: '',
									reference_type: '',
									reference_number: '',
									customer_number: '',
									channel: ''
							},
							issueList: [],
							enterList: [],
							alertStatus: false,
							attachments: [],
							allowedFileTypes: ['image/*', 'video/*', 'application/*']
					};
			},
			mounted: function mounted() {
					this.$validator.localize("en", this.dictionary);
			},
			created: function created() {
					var _this = this;
	
					console.log(this.$route.query);
					this.data.email = this.$route.query.Email;
					this.data.fName = this.$route.query.Name_First;
					this.data.lName = this.$route.query.Name_Last;
					this.data.issue = this.$route.query.Issue;
	
					this.data.reference_type = this.$route.query.ReferenceType;
					this.data.reference_number = this.$route.query.ReferenceNumber;
					this.data.customer_number = this.$route.query.CustomerNumber;
					this.data.channel = this.$route.query.Channel;
					_axios2.default.get("https://api-kencove.azurewebsites.net/api2/vue/cs_form/issue_types", {
							headers: {
									"Content-Type": "application/json;charset=UTF-8"
							}
					}).then(function (response) {
							var tempList = [];
							for (var i = 0; i < response.data.categories.length; i++) {
									tempList.push({ 'header': response.data.categories[i].name });
									for (var j = 0; j < response.data.categories[i].types.length; j++) {
											tempList.push({ 'name': response.data.categories[i].types[j].name, 'group': response.data.categories[i].name });
									}
							}
							_this.issueList = tempList;
					}).catch(function (error) {
							console.log(error.response);
					});
					_axios2.default.get("https://api-kencove.azurewebsites.net/api2/vue/cs_form/entered_by", {
							headers: {
									"Content-Type": "application/json;charset=UTF-8"
							}
					}).then(function (response) {
							_this.enterList = response.data;
					}).catch(function (error) {
							console.log(error.response);
					});
			},
	
			methods: {
					submitForm4: function submitForm4() {
							var _this2 = this;
	
							this.$validator.validateAll().then(function (valid) {
									if (valid) {
											console.log(_this2.data);
											_this2.alertStatus = _this2.$store.dispatch("submitForm4", _this2.data);
									}
							});
					},
					uploaded: function uploaded(fileData) {
							this.attachments.push(fileData);
							this.data.fileData.push(fileData);
					},
					closeIssue: function closeIssue() {
							if (this.$refs.issue.isMenuActive == true) this.$refs.issue.isMenuActive = false;
					},
					closeEnter: function closeEnter() {
							if (this.$refs.enter.isMenuActive == true) this.$refs.enter.isMenuActive = false;
					}
			}
	};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueUppyCloudinary = __webpack_require__(26);
	
	var _vueUppyCloudinary2 = _interopRequireDefault(_vueUppyCloudinary);
	
	__webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "form3",
	  components: {
	    VueUppyCloudinary: _vueUppyCloudinary2.default
	  },
	  $_veeValidate: {
	    validator: "new"
	  },
	  data: function data() {
	    return {
	      data: {
	        busName: "",
	        exemption: "Agricultural Production",
	        cust_num: "",
	        username: "",
	        cover: "state",
	        hold: false,
	        fileData: []
	      },
	      alertStatus: false,
	      attachments: [],
	      allowedFileTypes: ["image/*", "video/*", "application/*"],
	      download: '',
	      icon: __webpack_require__(87),
	      exemptionList: ["Agricultural Production", "Resale", "Industrial Production Or Manufacturing", "Government", "Charitable Organization"]
	    };
	  },
	  created: function created() {
	    console.log(this.$route.query);
	    this.data.cust_num = this.$route.query.cust_num;
	    this.data.username = this.$route.query.username;
	    this.download = this.$route.query.tax_form;
	  },
	  mounted: function mounted() {
	    this.$validator.localize("en", this.dictionary);
	  },
	
	  methods: {
	    submitForm3: function submitForm3() {
	      var _this = this;
	
	      this.$validator.validateAll().then(function (valid) {
	        if (valid) {
	          _this.alertStatus = _this.$store.dispatch("submitForm3", _this.data);
	        }
	      });
	    },
	    uploaded: function uploaded(fileData) {
	      this.attachments.push(fileData);
	      this.data.fileData.push(fileData);
	    },
	    closeType: function closeType() {
	      if (this.$refs.type.isMenuActive == true) this.$refs.type.isMenuActive = false;else this.$refs.type.isMenuActive = true;
	    }
	  }
	};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(9);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vueResource = __webpack_require__(25);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	_vue2.default.use(_vueResource2.default);
	
	_vue2.default.http.options.root = "http://localhost:4000/";
	
	exports.default = {
	  submitForm1: function submitForm1(_ref, data) {
	    var commit = _ref.commit,
	        state = _ref.state,
	        rootState = _ref.rootState;
	
	    axios.post("https://strapi-kencove.p.kencove.com/api/contact-form-results", { "data": data }, {
	      headers: {
	        "Content-Type": "application/json;charset=UTF-8"
	      }
	    }).then(function (response) {
	      console.log(response);
	      return;
	    }).catch(function (error) {
	      console.log(error.response);
	    });
	  },
	  submitForm2: function submitForm2(_ref2, data) {
	    var commit = _ref2.commit,
	        state = _ref2.state,
	        rootState = _ref2.rootState;
	
	    axios.post("https://api-kencove.azurewebsites.net/api2/kencove/vue/catalog", data, {
	      headers: {
	        "Content-Type": "application/json;charset=UTF-8"
	      }
	    }).then(function (response) {
	      console.log(response);
	      return;
	    }).catch(function (error) {
	      console.log(error.response);
	    });
	  },
	  submitForm3: function submitForm3(_ref3, data) {
	    var commit = _ref3.commit,
	        state = _ref3.state,
	        rootState = _ref3.rootState;
	
	    axios.post("https://api-kencove.azurewebsites.net/api2/kencove/vue/tax", data, {
	      headers: {
	        "Content-Type": "application/json;charset=UTF-8"
	      }
	    }).then(function (response) {
	      console.log(response);
	      return;
	    }).catch(function (error) {
	      console.log(error.response);
	    });
	  },
	  submitForm4: function submitForm4(_ref4, data) {
	    var commit = _ref4.commit,
	        state = _ref4.state,
	        rootState = _ref4.rootState;
	
	    axios.post("https://api-kencove.azurewebsites.net/api2/vue/cs_form/customer_interaction", data, {
	      headers: {
	        "Content-Type": "application/json;charset=UTF-8"
	      }
	    }).then(function (response) {
	      console.log(response);
	      return;
	    }).catch(function (error) {
	      console.log(error.response);
	    });
	  }
	};

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    interestsList: function interestsList(state) {
	        return state.interestsList;
	    },
	    alertStatus: function alertStatus(state) {
	        return state.alertStatus;
	    }
	};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.store = undefined;
	
	var _vuex = __webpack_require__(9);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _state = __webpack_require__(53);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _actions = __webpack_require__(49);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _mutations = __webpack_require__(52);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _getters = __webpack_require__(50);
	
	var _getters2 = _interopRequireDefault(_getters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = exports.store = new _vuex2.default.Store({
	    state: _state2.default,
	
	    getters: _getters2.default,
	
	    mutations: _mutations2.default,
	
	    actions: _actions2.default
	});

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    setInterestsList: function setInterestsList(state, payload) {
	        state.interestsList = payload;
	    },
	    setAlertStatus: function setAlertStatus(state, payload) {
	        state.alertStatus = payload;
	    },
	    setProfileHome: function setProfileHome(state, payload) {
	        state.profile.insure_building = payload.insure_building;
	        state.profile.insured_building_value = payload.insured_building_value;
	        state.profile.insure_household = payload.insure_household;
	        state.profile.insured_household_value = payload.insured_household_value;
	        state.profile.insure_portable_items = payload.insure_portable_items;
	        state.profile.insured_portable_value = payload.insured_portable_value;
	        state.profile.insure_domestic_employees = payload.insure_domestic_employees;
	        state.profile.indoor_employeers_num = payload.indoor_employeers_num;
	        state.profile.outdoor_employeers_num = payload.outdoor_employeers_num;
	    }
	};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    interestsList: ['Alpaca', 'Bees', 'Bison', 'Cattle/Beef', 'Dairy', 'Deer', 'Elk', 'Goat', 'Horse', 'Llama', 'Pigs', 'Poultry', 'Ostrich', 'Sheep', 'Plant/Garden', 'Vineyard', 'Other', 'Exclusion', 'Fence Contacting'],
	    alertStatus: false
	};

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(82)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(44),
	  /* template */
	  __webpack_require__(98),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(45),
	  /* template */
	  __webpack_require__(96),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(46),
	  /* template */
	  __webpack_require__(99),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(47),
	  /* template */
	  __webpack_require__(95),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(48),
	  /* template */
	  __webpack_require__(97),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-app', {
	    attrs: {
	      "id": "customer_form"
	    }
	  }, [_c('v-alert', {
	    attrs: {
	      "dismissible": "",
	      "type": "success"
	    },
	    model: {
	      value: (_vm.alertStatus),
	      callback: function($$v) {
	        _vm.alertStatus = $$v
	      },
	      expression: "alertStatus"
	    }
	  }, [_vm._v("We have recieved your tax exemption. Upon verification your status will be updated.")]), _vm._v(" "), _c('v-container', {
	    attrs: {
	      "grid-list-xl": ""
	    }
	  }, [_c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [_c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-text-field', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:20'),
	      expression: "'required|max:20'"
	    }],
	    attrs: {
	      "append-icon": "edit",
	      "counter": 20,
	      "error-messages": _vm.errors.collect('fname'),
	      "data-vv-name": "fname",
	      "required": "",
	      "label": "First Name"
	    },
	    model: {
	      value: (_vm.data.fName),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "fName", $$v)
	      },
	      expression: "data.fName"
	    }
	  })], 1), _vm._v(" "), _c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-text-field', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:20'),
	      expression: "'required|max:20'"
	    }],
	    attrs: {
	      "append-icon": "edit",
	      "counter": 20,
	      "error-messages": _vm.errors.collect('lname'),
	      "data-vv-name": "lname",
	      "required": "",
	      "label": "Last Name"
	    },
	    model: {
	      value: (_vm.data.lName),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "lName", $$v)
	      },
	      expression: "data.lName"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [_c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-text-field', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }],
	    attrs: {
	      "append-icon": "email",
	      "error-messages": _vm.errors.collect('email'),
	      "label": "Email",
	      "data-vv-name": "email",
	      "required": ""
	    },
	    model: {
	      value: (_vm.data.email),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "email", $$v)
	      },
	      expression: "data.email"
	    }
	  })], 1), _vm._v(" "), _c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "issue",
	    attrs: {
	      "items": _vm.issueList,
	      "label": "Issue",
	      "item-text": "name",
	      "item-value": "name",
	      "data-vv-name": "issue",
	      "require": ""
	    },
	    on: {
	      "click:append": _vm.closeIssue
	    },
	    scopedSlots: _vm._u([{
	      key: "selection",
	      fn: function(data) {
	        return [_vm._v(_vm._s(data.item.name))]
	      }
	    }, {
	      key: "item",
	      fn: function(data) {
	        return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
	          domProps: {
	            "textContent": _vm._s(data.item)
	          }
	        })] : [_c('v-list-tile-content', [_c('v-list-tile-title', {
	          domProps: {
	            "innerHTML": _vm._s(data.item.name)
	          }
	        })], 1)]]
	      }
	    }]),
	    model: {
	      value: (_vm.data.issue),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "issue", $$v)
	      },
	      expression: "data.issue"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [_c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm12": "",
	      "d-flex": ""
	    }
	  }, [_c('v-textarea', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:20'),
	      expression: "'required|min:20'"
	    }],
	    attrs: {
	      "name": "input-3-1",
	      "label": "What's wrong?",
	      "error-messages": _vm.errors.collect('description'),
	      "data-vv-name": "description",
	      "required": ""
	    },
	    model: {
	      value: (_vm.data.description),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "description", $$v)
	      },
	      expression: "data.description"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [_c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "enter",
	    attrs: {
	      "items": _vm.enterList,
	      "label": "Entered By",
	      "hint": "employee entering the ticket",
	      "data-vv-name": "enter",
	      "require": "",
	      "item-text": "text",
	      "item-value": "value"
	    },
	    on: {
	      "click:append": _vm.closeEnter
	    },
	    model: {
	      value: (_vm.data.enter),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "enter", $$v)
	      },
	      expression: "data.enter"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [_c('v-flex', {
	    attrs: {
	      "xs6": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('vue-uppy-cloudinary', {
	    attrs: {
	      "preset": "reqe2pqu",
	      "cloudName": "kencove",
	      "allowedFileTypes": _vm.allowedFileTypes
	    },
	    on: {
	      "uploaded": _vm.uploaded
	    }
	  })], 1), _vm._v(" "), (_vm.attachments.length != 0) ? _c('v-flex', {
	    attrs: {
	      "xs6": "",
	      "sm6": ""
	    }
	  }, [_c('h3', [_vm._v("Upload Files:")]), _vm._v(" "), _vm._l((_vm.attachments), function(item) {
	    return _c('ul', {
	      key: item.etag
	    }, [_c('li', [_vm._v(_vm._s(item.original_filename))])])
	  })], 2) : _vm._e(), _vm._v(" "), _c('v-flex', {
	    attrs: {
	      "xs6": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-btn', {
	    staticClass: "submit",
	    on: {
	      "click": _vm.submitForm4
	    }
	  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-app', [_c('v-alert', {
	    attrs: {
	      "dismissible": "",
	      "type": "success"
	    },
	    model: {
	      value: (_vm.alertStatus),
	      callback: function($$v) {
	        _vm.alertStatus = $$v
	      },
	      expression: "alertStatus"
	    }
	  }, [_vm._v("Success. Your catalog should arrive within the next week.")]), _vm._v(" "), _c('v-container', {
	    attrs: {
	      "grid-list-xl": ""
	    }
	  }, [_c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [_c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-text-field', {
	    attrs: {
	      "append-icon": "edit",
	      "label": "Company"
	    },
	    model: {
	      value: (_vm.data.company),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "company", $$v)
	      },
	      expression: "data.company"
	    }
	  })], 1), _vm._v(" "), _c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-text-field', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:20'),
	      expression: "'required|max:20'"
	    }],
	    attrs: {
	      "append-icon": "edit",
	      "error-messages": _vm.errors.collect('name'),
	      "data-vv-name": "name",
	      "required": "",
	      "label": "Full Name"
	    },
	    model: {
	      value: (_vm.data.name),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "name", $$v)
	      },
	      expression: "data.name"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [_c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-select', {
	    attrs: {
	      "items": _vm.countries,
	      "label": "Country"
	    },
	    model: {
	      value: (_vm.data.country),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "country", $$v)
	      },
	      expression: "data.country"
	    }
	  })], 1), _vm._v(" "), _c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "error-messages": _vm.errors.collect('region'),
	      "data-vv-name": "region",
	      "require": "",
	      "items": _vm.regions,
	      "label": "State"
	    },
	    model: {
	      value: (_vm.data.region),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "region", $$v)
	      },
	      expression: "data.region"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [_c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-text-field', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:50'),
	      expression: "'required|max:50'"
	    }],
	    attrs: {
	      "append-icon": "book",
	      "error-messages": _vm.errors.collect('address1'),
	      "data-vv-name": "address1",
	      "required": "",
	      "label": "Address 1"
	    },
	    model: {
	      value: (_vm.data.address1),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "address1", $$v)
	      },
	      expression: "data.address1"
	    }
	  })], 1), _vm._v(" "), (_vm.data.address1 != '') ? _c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-text-field', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('max:50'),
	      expression: "'max:50'"
	    }],
	    attrs: {
	      "append-icon": "book",
	      "error-messages": _vm.errors.collect('address2'),
	      "data-vv-name": "address2",
	      "label": "Address 2"
	    },
	    model: {
	      value: (_vm.data.address2),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "address2", $$v)
	      },
	      expression: "data.address2"
	    }
	  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [_c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-text-field', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:20'),
	      expression: "'required|max:20'"
	    }],
	    attrs: {
	      "append-icon": "edit",
	      "error-messages": _vm.errors.collect('city'),
	      "data-vv-name": "city",
	      "required": "",
	      "label": "City"
	    },
	    model: {
	      value: (_vm.data.city),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "city", $$v)
	      },
	      expression: "data.city"
	    }
	  })], 1), _vm._v(" "), _c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-text-field', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        regex: /^([0-9]{5}$)|(([ABC][0-9]){3})$/
	      }),
	      expression: "{regex: /^([0-9]{5}$)|(([ABC][0-9]){3})$/}"
	    }],
	    attrs: {
	      "append-icon": "edit",
	      "error-messages": _vm.errors.collect('zip'),
	      "data-vv-name": "zip",
	      "required": "",
	      "label": "Zip/Postal Code"
	    },
	    model: {
	      value: (_vm.data.zip),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "zip", $$v)
	      },
	      expression: "data.zip"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [_c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm4": "",
	      "d-flex": ""
	    }
	  }, [_c('v-text-field', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('email'),
	      expression: "'email'"
	    }],
	    attrs: {
	      "append-icon": "email",
	      "error-messages": _vm.errors.collect('email'),
	      "label": "Email",
	      "data-vv-name": "email",
	      "required": ""
	    },
	    model: {
	      value: (_vm.data.email),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "email", $$v)
	      },
	      expression: "data.email"
	    }
	  })], 1), _vm._v(" "), _c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm4": "",
	      "d-flex": ""
	    }
	  }, [_c('v-checkbox', {
	    attrs: {
	      "label": "Subscribe to Email List"
	    },
	    model: {
	      value: (_vm.data.subscribe),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "subscribe", $$v)
	      },
	      expression: "data.subscribe"
	    }
	  })], 1), _vm._v(" "), (_vm.data.email != '') ? _c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm4": "",
	      "d-flex": ""
	    }
	  }, [_c('v-text-field', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('max:20'),
	      expression: "'max:20'"
	    }],
	    attrs: {
	      "append-icon": "edit",
	      "error-messages": _vm.errors.collect('phone'),
	      "data-vv-name": "phone",
	      "label": "Phone"
	    },
	    model: {
	      value: (_vm.data.phone),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "phone", $$v)
	      },
	      expression: "data.phone"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.data.email == '') ? _c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm4": "",
	      "d-flex": ""
	    }
	  }, [_c('v-text-field', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:20'),
	      expression: "'required|max:20'"
	    }],
	    attrs: {
	      "append-icon": "edit",
	      "error-messages": _vm.errors.collect('phone'),
	      "data-vv-name": "phone",
	      "required": "",
	      "label": "Phone"
	    },
	    model: {
	      value: (_vm.data.phone),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "phone", $$v)
	      },
	      expression: "data.phone"
	    }
	  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [_c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm12": "",
	      "d-flex": ""
	    }
	  }, [_c('v-autocomplete', {
	    ref: "interests",
	    attrs: {
	      "items": _vm.interestsList,
	      "label": "Interests",
	      "append-icon-cb": _vm.closeInterests,
	      "multiple": "",
	      "chips": ""
	    },
	    scopedSlots: _vm._u([{
	      key: "selection",
	      fn: function(data) {
	        return [_c('v-chip', {
	          key: JSON.stringify(data.item),
	          staticClass: "chip--select-multi",
	          attrs: {
	            "close": "",
	            "selected": data.selected
	          },
	          on: {
	            "input": function($event) {
	              data.parent.selectItem(data.item)
	            }
	          }
	        }, [_vm._v("\n             " + _vm._s(data.item) + "\n            ")])]
	      }
	    }]),
	    model: {
	      value: (_vm.data.interests),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "interests", $$v)
	      },
	      expression: "data.interests"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [_c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-autocomplete', {
	    ref: "hear",
	    attrs: {
	      "items": _vm.hearList,
	      "label": "How did you hear about Kencove?",
	      "append-icon-cb": _vm.closeHear,
	      "multiple": "",
	      "chips": ""
	    },
	    scopedSlots: _vm._u([{
	      key: "selection",
	      fn: function(data) {
	        return [_c('v-chip', {
	          key: JSON.stringify(data.item),
	          staticClass: "chip--select-multi",
	          attrs: {
	            "close": "",
	            "selected": data.selected
	          },
	          on: {
	            "input": function($event) {
	              data.parent.selectItem(data.item)
	            }
	          }
	        }, [_vm._v("\n             " + _vm._s(data.item) + "\n            ")])]
	      }
	    }]),
	    model: {
	      value: (_vm.data.hear),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "hear", $$v)
	      },
	      expression: "data.hear"
	    }
	  })], 1), _vm._v(" "), _c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-text-field', {
	    attrs: {
	      "append-icon": "edit",
	      "label": "Which one?"
	    },
	    model: {
	      value: (_vm.data.which),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "which", $$v)
	      },
	      expression: "data.which"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [_c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm12": "",
	      "d-flex": ""
	    }
	  }, [_c('v-textarea', {
	    attrs: {
	      "name": "input-3-1",
	      "label": "Additional product information?",
	      "append-icon": "note"
	    },
	    model: {
	      value: (_vm.data.additional),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "additional", $$v)
	      },
	      expression: "data.additional"
	    }
	  })], 1)], 1), _vm._v(" "), _c('vue-recaptcha', {
	    attrs: {
	      "sitekey": "6LdddXsUAAAAAGHumerT5AvTLmu3ruDnZFCuY8M8"
	    }
	  }, [_c('v-btn', {
	    attrs: {
	      "color": "primary",
	      "dark": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.submitForm2($event)
	      }
	    }
	  }, [_vm._v("Order Catalog")])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-app', {
	    attrs: {
	      "id": "tax_form"
	    }
	  }, [_c('v-alert', {
	    attrs: {
	      "dismissible": "",
	      "type": "success"
	    },
	    model: {
	      value: (_vm.alertStatus),
	      callback: function($$v) {
	        _vm.alertStatus = $$v
	      },
	      expression: "alertStatus"
	    }
	  }, [_vm._v("We have recieved your tax exemption. Upon verification your status will be updated.")]), _vm._v(" "), _c('v-container', {
	    attrs: {
	      "grid-list-xl": ""
	    }
	  }, [_c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [_c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-text-field', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:20'),
	      expression: "'required|max:20'"
	    }],
	    attrs: {
	      "append-icon": "edit",
	      "counter": 20,
	      "error-messages": _vm.errors.collect('busname'),
	      "data-vv-name": "busname",
	      "required": "",
	      "label": "Business Name"
	    },
	    model: {
	      value: (_vm.data.busName),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "busName", $$v)
	      },
	      expression: "data.busName"
	    }
	  })], 1), _vm._v(" "), _c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-select', {
	    ref: "type",
	    attrs: {
	      "items": _vm.exemptionList,
	      "hint": 'Government',
	      "label": "Exemption Type",
	      "append-icon-cb": _vm.closeType
	    },
	    model: {
	      value: (_vm.data.exemption),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "exemption", $$v)
	      },
	      expression: "data.exemption"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [_c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-radio-group', {
	    attrs: {
	      "mandatory": true,
	      "row": ""
	    },
	    model: {
	      value: (_vm.data.cover),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "cover", $$v)
	      },
	      expression: "data.cover"
	    }
	  }, [_c('v-radio', {
	    attrs: {
	      "label": "Covers State",
	      "value": "state"
	    }
	  }), _vm._v(" "), _c('v-radio', {
	    attrs: {
	      "label": "Covers Nation",
	      "value": "nation"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-checkbox', {
	    attrs: {
	      "label": "Hold Order, mailing tax exemption form"
	    },
	    model: {
	      value: (_vm.data.hold),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "hold", $$v)
	      },
	      expression: "data.hold"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [_c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-btn', {
	    attrs: {
	      "color": "primary",
	      "href": _vm.download,
	      "target": "_blank",
	      "flat": ""
	    }
	  }, [_c('img', {
	    staticClass: "download_icon",
	    attrs: {
	      "src": _vm.icon,
	      "alt": ""
	    }
	  }), _vm._v("\n        Download tax exemption Certificate form")])], 1)], 1), _vm._v(" "), _c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [_c('v-flex', {
	    attrs: {
	      "xs6": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('vue-uppy-cloudinary', {
	    attrs: {
	      "preset": "reqe2pqu",
	      "cloudName": "kencove",
	      "allowedFileTypes": _vm.allowedFileTypes
	    },
	    on: {
	      "uploaded": _vm.uploaded
	    }
	  })], 1), _vm._v(" "), _c('v-flex', {
	    attrs: {
	      "xs6": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-btn', {
	    staticClass: "submit",
	    on: {
	      "click": _vm.submitForm3
	    }
	  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [(_vm.attachments.length != 0) ? _c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm12": ""
	    }
	  }, [_c('h3', [_vm._v("Upload Files:")]), _vm._v(" "), _vm._l((_vm.attachments), function(item) {
	    return _c('ul', {
	      key: item.etag
	    }, [_c('li', [_vm._v(_vm._s(item.original_filename))])])
	  })], 2) : _vm._e()], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-app', {
	    attrs: {
	      "id": "contact_form"
	    }
	  }, [_c('v-alert', {
	    attrs: {
	      "dismissible": "",
	      "type": "success"
	    },
	    model: {
	      value: (_vm.alertStatus),
	      callback: function($$v) {
	        _vm.alertStatus = $$v
	      },
	      expression: "alertStatus"
	    }
	  }, [_vm._v("This form was submitted successfully.")]), _vm._v(" "), _c('v-container', {
	    attrs: {
	      "grid-list-xl": ""
	    }
	  }, [_c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [_c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    ref: "to",
	    attrs: {
	      "error-messages": _vm.errors.collect('to'),
	      "items": _vm.people,
	      "label": "To",
	      "item-text": "text",
	      "item-value": "value",
	      "append-icon-cb": _vm.closeMenu,
	      "dense": ""
	    },
	    scopedSlots: _vm._u([{
	      key: "selection",
	      fn: function(data) {
	        return [_vm._v(_vm._s(data.item.text))]
	      }
	    }, {
	      key: "item",
	      fn: function(data) {
	        return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
	          domProps: {
	            "textContent": _vm._s(data.item)
	          }
	        })] : [_c('v-list-tile-content', [_c('v-list-tile-title', {
	          domProps: {
	            "innerHTML": _vm._s(data.item.text)
	          }
	        })], 1)]]
	      }
	    }]),
	    model: {
	      value: (_vm.data.to),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "to", $$v)
	      },
	      expression: "data.to"
	    }
	  })], 1), _vm._v(" "), _c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-text-field', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:20'),
	      expression: "'required|max:20'"
	    }],
	    attrs: {
	      "counter": 20,
	      "error-messages": _vm.errors.collect('from'),
	      "data-vv-name": "from",
	      "required": "",
	      "label": "From"
	    },
	    model: {
	      value: (_vm.data.from),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "from", $$v)
	      },
	      expression: "data.from"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [_c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-text-field', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }],
	    attrs: {
	      "error-messages": _vm.errors.collect('email'),
	      "data-vv-name": "email",
	      "required": "",
	      "label": "Email"
	    },
	    model: {
	      value: (_vm.data.email),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "email", $$v)
	      },
	      expression: "data.email"
	    }
	  })], 1), _vm._v(" "), _c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm6": "",
	      "d-flex": ""
	    }
	  }, [_c('v-text-field', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|max:50'),
	      expression: "'required|max:50'"
	    }],
	    attrs: {
	      "counter": 50,
	      "error-messages": _vm.errors.collect('subject'),
	      "data-vv-name": "subject",
	      "required": "",
	      "label": "Subject"
	    },
	    model: {
	      value: (_vm.data.subject),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "subject", $$v)
	      },
	      expression: "data.subject"
	    }
	  })], 1)], 1), _vm._v(" "), _c('v-layout', {
	    attrs: {
	      "wrap": "",
	      "align-center": ""
	    }
	  }, [_c('v-flex', {
	    attrs: {
	      "xs12": "",
	      "sm12": "",
	      "d-flex": ""
	    }
	  }, [_c('v-textarea', {
	    attrs: {
	      "name": "input-7-1",
	      "label": "Message"
	    },
	    model: {
	      value: (_vm.data.message),
	      callback: function($$v) {
	        _vm.$set(_vm.data, "message", $$v)
	      },
	      expression: "data.message"
	    }
	  })], 1)], 1), _vm._v(" "), _c('vue-recaptcha', {
	    attrs: {
	      "sitekey": "6LdddXsUAAAAAGHumerT5AvTLmu3ruDnZFCuY8M8"
	    }
	  }, [_c('v-btn', {
	    attrs: {
	      "color": "primary",
	      "dark": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.submitForm1($event)
	      }
	    }
	  }, [_vm._v("Send Email")])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.fe5075efb6add2d7d09c.js